import React from "react";
import dayjs from "dayjs";

export default function RecordRow({ label, value, location = false, locationData = {} }) {
  const formatAddress = () => {
    if (location && locationData) {
      const { city, state, country } = locationData;

      const addressParts = [city, state, country].filter((part) => part);

      if (addressParts.length === 0) {
        return "-";
      }
      return addressParts.join(", ");
    } else {
      return "-";
    }
  };
  if (location) {
    return (
      <div className="space-y-1">
        <span className="text-sm block w-full">{label}:</span>
        <span className="text-gray-900 text-sm font-semibold break-words block">{formatAddress()}</span>
      </div>
    );
  }
  return (
    <>
      <div className="space-y-1">
        <span className="text-sm block w-full">{label}:</span>
        <span className="text-gray-900 text-sm font-semibold break-words block">{value ? value : "-"}</span>
      </div>
    </>
  );
}
